import {
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  configApiRef,
  fetchApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { PrometheusAPI, prometheusApiRef } from './api/PrometheusApi';
import { AiForecastAPI, aiForecastApiRef } from './api/AiForecastApi';

export const prometheusPlugin = createPlugin({
  id: 'prometheus',
  apis: [
    createApiFactory({
      api: prometheusApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        configApi: configApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, configApi, fetchApi }) => {
        return new PrometheusAPI({
          discoveryApi,
          configApi,
          fetchApi,
        });
      },
    }),
    createApiFactory({
      api: aiForecastApiRef,
      deps: {
        configApi: configApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ configApi, fetchApi }) => {
        return new AiForecastAPI({
          configApi,
          fetchApi,
        });
      },
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const PrometheusPage = prometheusPlugin.provide(
  createRoutableExtension({
    name: 'PrometheusPage',
    component: () =>
      import('./components/WrapperComponent').then(m => m.WrapperComponent),
    mountPoint: rootRouteRef,
  }),
);